import Address from '../../../models/Address';
import { CloneMode } from '../../../services/admin/BackendService';
import React from 'react';
import { FundOpportunityLayoutHandlers } from './FundOpportunityLayout';
import { FundOpportunityAdminState } from './types';

export interface FundOpportunityAdminHandlerHost {
  clearToast: () => void;
  showToast: (
    message: string,
    type: FundOpportunityAdminState['toastType'],
    autoHideDuration?: number,
  ) => void;
  openCloneModal: () => void;
  closeCloneModal: () => void;
  openReviewRequestModal: () => void;
  openDeleteModal: () => void;
  closeDeleteModal: () => void;
  handleDelete: (force?: boolean) => Promise<void>;
  handleClone: (mode: CloneMode, newName: string, destinationExternalId?: string) => void;
  loadData: () => void;
  handleInputChange: (
    field: keyof FundOpportunityAdminState['formData'],
    value: string | number | string[] | boolean,
    callback?: () => void,
  ) => void;
  handleSectorChange: (
    sectorOption: FundOpportunityAdminState['formData']['sector'][number],
  ) => void;
  handleSubmit: () => void;
  handleFundStatusClose: () => void;
  handleFundStatusConfirm: () => void;
  props: { navigate: (path: string) => void };
  setState: React.Component<
    import('./types').FundOpportunityAdminWithNavigationProps,
    FundOpportunityAdminState
  >['setState'];
}

export function createFundOpportunityLayoutHandlers(
  component: FundOpportunityAdminHandlerHost,
): FundOpportunityLayoutHandlers {
  return {
    clearToast: component.clearToast,
    showToast: component.showToast,
    openCloneModal: component.openCloneModal,
    closeCloneModal: component.closeCloneModal,
    openReviewRequestModal: component.openReviewRequestModal,
    openDeleteModal: component.openDeleteModal,
    closeDeleteModal: component.closeDeleteModal,
    handleDelete: component.handleDelete,
    handleClone: component.handleClone,
    loadData: component.loadData,
    handleInputChange: component.handleInputChange,
    handleSectorChange: component.handleSectorChange,
    handleSubmit: component.handleSubmit,
    handleFundStatusClose: component.handleFundStatusClose,
    handleFundStatusConfirm: component.handleFundStatusConfirm,
    onNavigate: component.props.navigate,
    onFieldErrors: (errors) => component.setState({ fieldErrors: errors }),
    onAddressesChange: (addresses: Address[]) => component.setState({ addresses }),
    onLocationDetailsChange: (details: { country?: string; state?: string }) =>
      component.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          country: prevState.formData.country || details.country || prevState.formData.country,
          state: prevState.formData.state || details.state || prevState.formData.state,
        },
      })),
    onLocationLoadingChange: (loading) => component.setState({ isSubmitting: loading }),
    onShowAddInvestorChange: (show) => component.setState({ addInvestor: show }),
    onInvestorFilterChange: (filter) => component.setState({ investorFilter: filter }),
  };
}
